import http from '../../http'
let list = (params) => {
    return http.get('opservice/field/list', params)
}
export default {
    list
}
